import http from "@http"

//接口地址
let API = {
    //查询评论列表接口
    COMMENT_URL : "/comment/commentList",
   
}


//获取评论列表
export function getComment(data){
    return http.post(API.COMMENT_URL,data)
}


